<span>{{ ticket?.extra_flags?.gp_priority }}</span>
